import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { legalFormActions } from '../../../../../actions/legalFormActions';
import LegalFormsForm from './LegalFormsForm';

const LegalFormModal = props => {
  const { legalForms, handleSubmit, handleModalClose } = props;

  return (
    <Dialog
      open={legalForms.showFormModal}
      onClose={handleModalClose}
      aria-labelledby="form-dialog-title"
    >
      <Toolbar className="text-center">
        <Typography variant="title" color="inherit" className="flex">
          {legalForms.currentItem ? 'Редактирование формы' : 'Создание формы'}
        </Typography>
        <IconButton color="inherit" onClick={handleModalClose}>
          <CloseIcon className="blue" />
        </IconButton>
      </Toolbar>

      <DialogContent className="dialog text-center">
        <LegalFormsForm currentItem={legalForms.currentItem} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = state => {
  const { legalForms } = state;

  return {
    legalForms
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { legalForms } = stateProps;
  const { dispatch } = dispatchProps;

  const handleSubmit = (values, dispatch) => {
    if (legalForms.currentItem && legalForms.currentItem.id) {
      return dispatch(legalFormActions.update(values));
    }
    return dispatch(legalFormActions.create(values));
  };

  const handleModalClose = () => {
    dispatch(legalFormActions.closeFormModal());
  };

  return {
    ...ownProps,
    legalForms,
    handleSubmit,
    handleModalClose
  };
};

const connectedLegalFormModal = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LegalFormModal);

export { connectedLegalFormModal as LegalFormModal };
